import { CSSObject } from '@chakra-ui/react';

export const RaceMeetingsList: CSSObject = {
  px: '0',
  pb: '4',
  mt: '3',
};

export const BoxWrapper: CSSObject = {};
